import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import {
  CheckCircleOutlined,
  SyncOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { useStage } from '../../Provider';
import { useStores } from '@/hooks/use-stores';

export const StatusTag = observer(() => {
  const { t } = useTranslation();
  const {
    lifecycleStore: {
      activeStageTimer: { timerString, isWithin24Hours, isPeriodPassed },
    },
  } = useStores();
  const { isCurrent, isFinished, endTime, isBlocked, lastBlockPeriod, expectedDuration } = useStage();
  const hasExpectedDuration = !!expectedDuration;

  let tagProps: { color: string; icon: React.ReactNode; label: string };
  switch (true) {
    case isBlocked:
      tagProps = {
        color: 'error',
        icon: <StopOutlined />,
        label: `${t('Blocked from')}: ${dayjs(lastBlockPeriod?.start).format('MMM DD, YYYY')}`,
      };
      break;
    case isFinished:
      tagProps = {
        color: 'success',
        icon: <CheckCircleOutlined />,
        label: `${t('Completed')}: ${dayjs(endTime).format('MMM DD, YYYY')}`,
      };
      break;
    case isCurrent && isPeriodPassed && hasExpectedDuration:
      tagProps = {
        color: 'error',
        icon: <CloseCircleOutlined />,
        label: `${t('Overdue')}`,
      };
      break;
    case isCurrent && isWithin24Hours && hasExpectedDuration:
      tagProps = {
        color: 'orange',
        icon: <ExclamationCircleOutlined />,
        label: `${t('Time to complete')}: ${timerString || '--:--:--'}`,
      };
      break;
    case isCurrent && hasExpectedDuration:
      tagProps = {
        color: 'blue',
        icon: <SyncOutlined />,
        label: `${t('Time to complete')}: ${timerString || '--:--:--'}`,
      };
      break;
  }
  if (!tagProps) return <></>;

  return (
    <div className="stage-status-tag">
      <Tag color={tagProps.color}>
        {tagProps.icon} {tagProps.label}
      </Tag>
    </div>
  );
});
